export default "__VITE_PUBLIC_ASSET__57b1b03c__"